import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { TextArea } from '@alefeducation/ui-elements-library-core';
import { ToggleRender } from '../common/ToggleRender/ToggleRender';
import {
  CommentContainer,
  PreviewContainer,
} from '../common/AssignmentPageLayout/AssignmentPageLayout';

export const AssignmentComment = ({
  isSubmitted,
  comment,
  isAddCommentActive,
  onCommentChange,
  setPreviewActive,
  setAutoHeight,
  isCommentPreviewActive,
  setUpdateCommentActive,
  commentRequired,
  attachmentRequired,
}) => {
  const { t } = useTranslation();

  return (!commentRequired && !attachmentRequired) ||
    (isSubmitted && !comment) ||
    (!isAddCommentActive && !comment) ? null : (
    <ToggleRender label={t('Comments')} defaultVisible={true}>
      {isAddCommentActive ? (
        <CommentContainer>
          <TextArea
            className="usprivacy"
            autofocus={true}
            onChange={onCommentChange}
            value={comment}
            data-testid="submission-comment-textarea"
            placeholder={t('Enter your comment here')}
            onBlur={() => {
              setPreviewActive();
            }}
            onFocus={setAutoHeight}
            disabled={isSubmitted}
          />
        </CommentContainer>
      ) : null}
      {isCommentPreviewActive ? (
        <PreviewContainer
          className="usprivacy"
          isSubmitted={isSubmitted}
          data-testid="comment-preview"
          onClick={isSubmitted ? undefined : setUpdateCommentActive}
          dangerouslySetInnerHTML={{
            __html: comment.replace(/\n/g, '<br />'),
          }}
        />
      ) : null}
    </ToggleRender>
  );
};

AssignmentComment.propTypes = {
  isSubmitted: PropTypes.bool.isRequired,
  comment: PropTypes.string.isRequired,
  isAddCommentActive: PropTypes.bool.isRequired,
  onCommentChange: PropTypes.func.isRequired,
  setPreviewActive: PropTypes.func.isRequired,
  setAutoHeight: PropTypes.func.isRequired,
  isCommentPreviewActive: PropTypes.bool.isRequired,
  commentRequired: PropTypes.bool.isRequired,
  attachmentRequired: PropTypes.bool.isRequired,
  setUpdateCommentActive: PropTypes.func.isRequired,
};
